import React, { ReactElement } from 'react';
import classNames from 'classnames/bind';
import styles from 'sections/Resources/BillOfLading/components/SectionTakeaways/SectionTakeaways.module.scss';

const cn = classNames.bind(styles);

const SectionTakeaways = (): ReactElement => {
  return (
    <section className={cn('takeaways')}>
      <div className={cn('container')}>
        <h2 className={cn('takeaways__heading')}>Key Takeaways</h2>

        <ul className={cn('takeaways__benefits')}>
          <li className={cn('takeaways__benefit')}>
            <p className={cn('takeaways__benefit-paragraph')}>
              1. &nbsp;A Bill of Lading (BoL) is a crucial legal document provided by a carrier to a shipper that
              outlines the type, quantity, and destination of the goods being transported.
            </p>
          </li>
          <li className={cn('takeaways__benefit')}>
            <p className={cn('takeaways__benefit-paragraph')}>
              2. &nbsp;It serves multiple roles: as a document of title, a receipt for the shipped goods, and a
              contract between the carrier and the shipper.
            </p>
          </li>
          <li className={cn('takeaways__benefit')}>
            <p className={cn('takeaways__benefit-paragraph')}>
              3. &nbsp;This essential document must accompany the goods during shipment and requires
              signatures from authorized representatives of the carrier, shipper, and receiver to be valid.
            </p>
          </li>
          <li className={cn('takeaways__benefit')}>
            <p className={cn('takeaways__benefit-paragraph')}>
              4. &nbsp;Proper management and review of a Bill of Lading can significantly reduce the risk of asset
              theft during transit.
            </p>
          </li>
          <li className={cn('takeaways__benefit')}>
            <p className={cn('takeaways__benefit-paragraph')}>
              5. &nbsp;There are various types of Bills of Lading, each with specific purposes, making it critical to
              select the appropriate one for your shipment.
            </p>
          </li>
        </ul>
      </div>
    </section>
  );
};

export default SectionTakeaways;